import httpClient from "@/API/HttpClient";
import AuthClient from "@/API/AuthClient";

// Login
const login = (params) =>
  AuthClient.post(`connect/token`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
const getUserInfo = () => httpClient.get(`userInfo`);
const getNotificationList = () => httpClient.get(`Signal`);
const setNotificationAsRead = (id) => httpClient.put(`Signal?signalid=${id}`);
const postFCMToken = (FireBaseToken) =>
  httpClient.post(`SubscribeToTopic?FireBaseToken=${FireBaseToken}`);

// Menu
const getMenu = () => httpClient.get(`Menu`);
const getSubMenu = (id) => httpClient.get(`Menu/${id}`);

// Location
const getLocations = () => httpClient.get(`Location`);
const getCeremonyHalls = () => httpClient.get(`CeremonyHall`);

const getCustomerInfo = (phone) =>
  httpClient.get(`CustomerInfoByPhone?phone=${phone}`);

// Factor
const getFactorHistory = (deskNumber, createByCustomer) =>
  httpClient.get(
    `FactorTrack?desknumber=${deskNumber || ""}&iscreatebycustomer=${
      createByCustomer || ""
    }`
  );
const getFactorById = (Id) => httpClient.get(`FactorById?Id=${Id}`);
const postFactor = (factor, issave) =>
  httpClient.post(`CreateFACTOR?issave=${issave}`, factor);
const updateFactor = (factor, issave) =>
  httpClient.put(`UpdateFACTOR?issave=${issave}`, factor);
const deleteFactor = (factor) =>
  httpClient.delete(`DeleteFACTOR`, { data: factor });
const updateFactorHeader = (factor) =>
  httpClient.put(`UpdateHeaderFACTOR`, factor);
const getTagList = (Id) => httpClient.get(`TagList?kala=${Id}`);
const postFoodDelivered = (Id, kindfood) =>
  httpClient.put(`UpdateKitchenState?Id=${Id}&kindfood=${kindfood}`, {
    Id,
    kindfood,
  });
const checkOut = (factor) => httpClient.post(`CheckOut`, factor);

// Notes
const getCeremonyType = () => httpClient.get(`CeremonyType`);
const getCeremonyFamiliarity = () => httpClient.get(`METHODS_INTRODUCE_CLUB`);
const getCeremonies = (pageNumber, year, month, day) =>
  httpClient.get(
    `HCeremonyList?pageSize=5&includeCount=true&pageNumber=${pageNumber}&year=${year}&month=${month}&day=${day}`
  );
const getSuggest = (pageNumber) =>
  httpClient.get(
    `GET_Survey?pageSize=5&includeCount=true&pageNumber=${pageNumber}`
  );
const getCeremony = (id) => httpClient.get(`HCeremony/${id}`);
const postCeremony = (note) => httpClient.post(`HCeremony`, note);
const updateCeremony = (id, note) => httpClient.put(`HCeremony?id=${id}`, note);
const postCeremonyFollowUp = (followUp) =>
  httpClient.post(`CreateDCeremony`, followUp);
const updateCeremonyFollowUp = (followUp) =>
  httpClient.put(`UpdateDCeremony`, followUp);

// Charge Request
const postChargeRequest = (chargeRequest) =>
  httpClient.post(`RequestCharge`, chargeRequest);

// Management Reports
const UploadImage = (params, typeHeader, menuCodeHeader, productCodeHeader) =>
  httpClient.post("UploadImage", params, {
    headers: {
      "Content-Type": "multipart/form-data",
      TypeHeader: typeHeader,
      MenuCodeHeader: menuCodeHeader,
      ProductCodeHeader: productCodeHeader,
    },
  });

// const UploadImage = (
//   file,
//   typeHeader,
//   menuCodeHeader,
//   productCodeHeader,
//   bannertopapp
// ) => {
//   const formData = new FormData();
//   formData.append("Logo", file); // فقط فایل را به فرم دیتا اضافه کنید

//   return httpClient.post("UploadImage", formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       TypeHeader: typeHeader.toString(), // نوع آپلود به عنوان هدر
//       MenuCodeHeader: menuCodeHeader,
//       ProductCodeHeader: productCodeHeader,
//       Bannertopapp: bannertopapp,
//     },
//   });
// };

const getOrderTypeReport = (timetype, numberType, year, month, day) =>
  httpClient.get(`TickeByWaiter`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });
const getLocationTypeReport = (timetype, numberType, year, month, day) =>
  httpClient.get(`TickeByLocation`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });
const getFoodTypeReport = (timetype, numberType, id, year, month, day) =>
  httpClient.get(`TickeByFoodType`, {
    params: {
      timetype,
      numberType,
      id,
      year,
      month,
      day,
    },
  });

const getNewFoodTypeReport = (
  timetype,
  numberType,
  id1,
  id2,
  id3,
  year,
  month,
  day
) =>
  httpClient.get(`NewTickeByFoodType`, {
    params: {
      timetype,
      numberType,
      id1,
      id2,
      id3,
      year,
      month,
      day,
    },
  });

const getFoodTreeMap = (timetype, numberType, year, month, day) =>
  httpClient.get(`TickeByFood`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });
const getNewCustomerCount = (timetype, numberType, year, month, day) =>
  httpClient.get(`NewCustomerCount`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });
const getSummeryData = (timetype, year, month, day) =>
  httpClient.get(`HeaderData`, {
    params: {
      timetype,
      year,
      month,
      day,
    },
  });

//Salon

const getHallUserCount = (timetype, year, month, day) =>
  httpClient.get(`HallUserCount`, {
    params: {
      timetype,
      year,
      month,
      day,
    },
  });

// AnalyticsHotel

const getSummeryDataHotel = (timetype, year, month, day) =>
  httpClient.get(`HotelHeaderdata`, {
    params: {
      timetype,
      year,
      month,
      day,
    },
  });
const getCountByCity = (timetype, numberType, year, month, day) =>
  httpClient.get(`CountByCity`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });
const getCountByJob = (timetype, numberType, year, month, day) =>
  httpClient.get(`CountByJob`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });
const getCountByOrganization = (timetype, numberType, year, month, day) =>
  httpClient.get(`CountByOrganization`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });
const getCountByNashnality = (timetype, numberType, year, month, day) =>
  httpClient.get(`CountByNashnality`, {
    params: {
      timetype,
      numberType,
      year,
      month,
      day,
    },
  });

// Send Notification
const sendNotification = (title, message, to) =>
  httpClient.get(`signalToAll`, { params: { title, message, to } });

// User Management
const getUsersList = () => httpClient.get(`Users`);
const getRolesList = () => httpClient.get(`Roles`);
const createUser = (user) => httpClient.post(`Register`, user);
const updateUser = (user) => httpClient.put(`ChangeUser`, user);

// Monitoring
const getMonitors = () => httpClient.get(`monitors`);
const getMonitorOrders = (monitorid, StateId) =>
  httpClient.get(`monitor?monitorid=${monitorid}&StateId=${StateId}`);

const getDeliveryBoyList = (monitoringId) =>
  httpClient.get(`deliveryBoyList?monitoringid=${monitoringId}`);
const createDeliveryBoy = (name, isdisable, monitorid) =>
  httpClient.post(`deliveryBoyInsert`, null, {
    params: {
      name,
      isdisable,
      monitorid,
    },
  });
const updateDeliveryBoy = (Code, Name, IsDisable, monitorid) =>
  httpClient.put(`deliveryBoyUpdate`, null, {
    params: {
      Code,
      Name,
      IsDisable,
      monitorid,
    },
  });

const getChargeFoodList = (monitoringId) =>
  httpClient.get(`chargeFoodList?monitorid=${monitoringId}`);
const postChargeFood = (monitoringId, foodId, qty) =>
  httpClient.post(
    `chargeFood?monitoringid=${monitoringId}&foodid=${foodId}&qty=${qty}`
  );
const toggleFoodState = (foodId, status) =>
  httpClient.post(`toggleFood?approvalid=${foodId}&status=${status}`);

const getMonitorSummaryList = (monitoringId) =>
  httpClient.get(`MonitoringSummuryList?monitorid=${monitoringId}`);
const changeOrderState = (
  order,
  monitorid,
  statenew,
  statebefor,
  deliverid,
  waitetime
) =>
  httpClient.put(`ChangeOrderState`, order, {
    params: {
      monitorid,
      statenew,
      statebefor,
      deliverid,
      waitetime,
    },
  });
const getMonitorReports = (
  reporttype,
  monitorid,
  FactorNumber,
  CustomerName,
  FactorTable,
  FactorStatus,
  FactorShift
) =>
  httpClient.get(`report`, {
    params: {
      reporttype,
      monitorid,
      FactorShift,
      FactorStatus,
      CustomerName,
      FactorNumber,
      FactorTable,
    },
  });
const getFactorExtraItems = (headerid) =>
  httpClient.get(`FactorExtraItem?hedearid=${headerid}`);

const getKalaOption = (kalacode) =>
  httpClient.get(`KalaOption?kalacode=${kalacode}`);

const insertNewTeste = (newList) => httpClient.post(`KalaOption`, newList);

export {
  login,
  postFCMToken,
  getUserInfo,
  getNotificationList,
  setNotificationAsRead,
  getMenu,
  getSubMenu,
  getLocations,
  getCeremonyHalls,
  getCustomerInfo,
  getFactorById,
  postFactor,
  updateFactor,
  deleteFactor,
  getFactorHistory,
  updateFactorHeader,
  getCeremonyType,
  getCeremonyFamiliarity,
  getCeremonies,
  getCeremony,
  postCeremony,
  updateCeremony,
  postCeremonyFollowUp,
  updateCeremonyFollowUp,
  postChargeRequest,
  getOrderTypeReport,
  getLocationTypeReport,
  getFoodTypeReport,
  getNewFoodTypeReport,
  sendNotification,
  getNewCustomerCount,
  getFoodTreeMap,
  getSummeryData,
  getTagList,
  postFoodDelivered,
  getUsersList,
  getRolesList,
  createUser,
  updateUser,
  getSummeryDataHotel,
  getCountByCity,
  getCountByJob,
  getCountByOrganization,
  getCountByNashnality,
  getMonitors,
  getMonitorOrders,
  getDeliveryBoyList,
  createDeliveryBoy,
  updateDeliveryBoy,
  getChargeFoodList,
  postChargeFood,
  getMonitorSummaryList,
  changeOrderState,
  toggleFoodState,
  getMonitorReports,
  getFactorExtraItems,
  UploadImage,
  checkOut,
  getSuggest,
  getHallUserCount,
  getKalaOption,
  insertNewTeste,
};
